import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { getDriver } from 'src/selectors/driver'

const RecollectionHeroComponent = () => {
  const driver = useSelector(getDriver)

  return (
    <div css={tw`bg-primary-800 w-full px-4 pt-8 pb-6`}>
      <Typography variant="overline" css={tw`text-primary-200`}>
        {`Hi, ${driver?.firstName || ''}`}
      </Typography>
      <Typography variant="h1" css={tw`text-shades-0 mt-1`}>
        Renew to Stay Active
      </Typography>
      <Typography css={tw`text-primary-200 mt-2`}>
        Some documents have expired or are expiring soon. Tap any card in Action needed to renew —
        progress saves after each step.
      </Typography>
    </div>
  )
}

export const RecollectionHero = memo(RecollectionHeroComponent)
